import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {PopUpTypeEnum, ProgressTypeEnum} from './PopUpBenefitEnum';
import {
  gAUpdatePopUpAlreadyBenefitButtonAnotherTimeClick,
  gAUpdatePopUpAlreadyUsedBenefitButtonSubmitClick,
  gAUpdatePopUpAlreadyUsedBenefitShow,
  gAUpdatePopUpBenefitButtonAnotherTimeClick,
  gAUpdatePopUpBenefitButtonSubmitClick,
  gAUpdatePopUpBenefitShow,
  gAUpdatePopUpWithoutBenefitShow,
  gAUpdatePopUpOutOfStockBenefitShow,
  gAUpdatePopUpWithoutBenefitButtonSubmitClick,
  gAUpdatePopUpWithoutBenefitButtonAnotherTimeClick,
  gAUpdatePopUpOutOfStockBenefitButtonSubmitClick,
  gAUpdatePopUpOutOfStockBenefitButtonAnotherTimeClick,
} from './gaReports';

export const getBenefit = createAsyncThunk('UpdateCustomerDetails/GetBenefit', async (blockId, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('benefitData', [blockId]);
    return result?.Body;
  } catch (error) {
    return {
      error: true,
      reason: error,
    };
  }
});

export const updateContactAndAccountDetailsPopUpOnly = createAsyncThunk(
  'UpdateCustomerDetails/UpdateContactAndAccountDetailsPopUpOnly',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('updateContactAndAccountDetailsPopUpOnly', []);
      return result;
    } catch (error) {
      return {
        error: true,
        reason: error,
      };
    }
  }
);

const benefitBlockContent = {
  isReady: false,
  blockId: 0,
};

const popUpBenefit = {
  progressType: ProgressTypeEnum.Browser,
  popUpType: PopUpTypeEnum.Unknown,
};

const initialState = {
  isShowPopup: false,
  isAllowBenefit: false,
  isAlreadyUsedBenefit: false,
  isBenefitOutOfStock: false,
  isReady: false,
  isPrepared: false,
  popUpBenefit: popUpBenefit,
  benefitBlockContent: benefitBlockContent,
};

const benefitSlice = createSlice({
  name: 'benefit',
  initialState: initialState,

  reducers: {
    resetBlock: (state) => initialState,
    setIsShowPopup: (state, action) => {
      state.isShowPopup = action.payload;
      return state;
    },
    setProgressType: (state, action) => {
      state.popUpBenefit.progressType = action.payload;
      return state;
    },
    setPopUpType: (state, action) => {
      state.popUpBenefit.popUpType = action.payload;
      return state;
    },
    setIsPrepared: (state, action) => {
      state.isPrepared = action.payload;
      return state;
    },
    setBenefitBlockContent: (state, action) => {
      state.benefitBlockContent.blockId = action.payload;
      state.benefitBlockContent.isReady = true;
      return state;
    },
    setBenefitBlockState: (state,action) => {
      state.benefitBlockContent.isReady = action.payload;
      return state;
    },
    reportPopUpShow: (state) => {
      switch (state.popUpBenefit.popUpType) {
        case PopUpTypeEnum.WithBenefit:
          gAUpdatePopUpBenefitShow(state.popUpBenefit.progressType);
          break;
        case PopUpTypeEnum.AlreadyUsedBenefit:
          gAUpdatePopUpAlreadyUsedBenefitShow(state.popUpBenefit.progressType);
          break;
        case PopUpTypeEnum.OutOfStockBenefit:
          gAUpdatePopUpOutOfStockBenefitShow();
          break;
        default:
          gAUpdatePopUpWithoutBenefitShow();
          break;
      }
    },
    reportPopUpAction: (state, action) => {
      let actionType = action.payload;
      switch (actionType) {
        case 'submit':
          switch (state.popUpBenefit.popUpType) {
            case PopUpTypeEnum.WithBenefit:
              gAUpdatePopUpBenefitButtonSubmitClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.AlreadyUsedBenefit:
              gAUpdatePopUpAlreadyUsedBenefitButtonSubmitClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.OutOfStockBenefit:
              gAUpdatePopUpOutOfStockBenefitButtonSubmitClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.WithOutBenefit:
              gAUpdatePopUpWithoutBenefitButtonSubmitClick(state.popUpBenefit.progressType);
              break;
          }
        case 'remind':
          switch (state.popUpBenefit.popUpType) {
            case PopUpTypeEnum.WithBenefit:
              gAUpdatePopUpBenefitButtonAnotherTimeClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.AlreadyUsedBenefit:
              gAUpdatePopUpAlreadyBenefitButtonAnotherTimeClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.OutOfStockBenefit:
              gAUpdatePopUpOutOfStockBenefitButtonAnotherTimeClick(state.popUpBenefit.progressType);
              break;
            case PopUpTypeEnum.WithOutBenefit:
              gAUpdatePopUpWithoutBenefitButtonAnotherTimeClick(state.popUpBenefit.progressType);
              break;
          }

        default:
          break;
      }
    },
  },
  extraReducers: {
    [getBenefit.pending]: (state, action) => {},
    [getBenefit.fulfilled]: (state, action) => {
      if (action.payload != undefined && action.payload != null) {
        state.isAllowBenefit = action.payload.isAllowBenefit;
        state.isAlreadyUsedBenefit = action.payload.isAlreadyUsedBenefit;
        state.isBenefitOutOfStock = action.payload.isBenefitOutOfStock;
        state.isShowPopup = action.payload.isShowPopUp;
        state.isReady = true;
      }
      return state;
    },
    [updateContactAndAccountDetailsPopUpOnly.fulfilled]: (state, action) => {},
  },
});

export const {
  setIsShowPopup,
  resetBlock,
  reportPopUpShow,
  reportPopUpAction,
  setProgressType,
  setIsPrepared,
  setPopUpType,
  setBenefitBlockContent,
  setBenefitBlockState
} = benefitSlice.actions;
export default benefitSlice.reducer;
